<template>
  <div>
    <div id="search-form" class="container input-group">
      <input type="text" class="form-control" placeholder="Search for..." aria-label="Search for..." v-model="keyword">
      <span class="input-group-btn">
        <button class="btn btn-secondary" type="button" v-on:click="move">Go!</button>
      </span>
    </div>

    <div class="container-fluid">
      <div id="result-view" class="row">
        <div class="col">
          <div class="container">
            <div class="row">
              <div class="col text-right">
                「{{ lastKeyword }}」のヒット数: {{ total }}件 (最大100件まで表示)
              </div>
            </div>
          </div>
        </div>
        <div class="w-100"></div>
        <div class="card mx-auto" v-for="result in results" :key="result.url">
          <a v-bind:href="result.url">
            <img class="card-img-top" v-bind:src="result.image">
            <div class="card-body">
              <h6 class="card-title">{{ result.title }}</h6>
            </div>
          </a>
          <div id="tags" class="card-footer">
            <a v-for="tag in result.tags" :key="tag" v-bind:href="'http://www.irasutoya.com/search/label/' + tag" class="badge badge-primary">{{ tag }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

// 本当は$route.query['query']をkeyword相当としてbindしたいが
// 技術的に無理っぽいのでwatchを使って両者をお互いにマニュアルでbindするような
// 形にする
// 参考: https://stackoverflow.com/questions/46878528/vuejs-bind-input-to-url-param
export default {
  name: 'Search',
  metaInfo () {
    return {
      title: '「' + this.$route.query['query'] + '」の検索結果'
    }
  },
  data () {
    return {
      keyword: this.$route.query['query'] || '',
      results: [],
      total: 0,
      lastKeyword: ''
    }
  },
  watch: {
    // keywordから$route.query['query']への(実質的な)bind
    keyword: {
      immediate: true,
      handler: _.debounce(function (keyword) {
        this.updateResults()
        this.move()
      }, 500)
    },
    // $route.query['query']からkeywordへの(実質的な)bind
    '$route.query': function () {
      this.keyword = this.$route.query['query'] || ''
    }
  },
  methods: {
    // 検索ボタンからも一応呼び出しているのでここに置かざるを得ない
    move: function (event) {
      this.$router.push({
        name: 'Search',
        query: { query: this.keyword }}
      )
    },
    updateResults: function () {
      const url = 'https://wy59x9hce3.execute-api.ap-northeast-1.amazonaws.com'
      const queryingKeyword = this.keyword
      if (this.keyword === '') {
        this.results = []
        this.total = 0
        this.lastKeyword = queryingKeyword
      } else {
        axios.get(url + '/Prod/search', { params: { keyword: queryingKeyword } })
          .then(response => {
            this.results = this._getResultsByHits(response.data.hits.hits)
            this.total = response.data.hits.total
            this.lastKeyword = queryingKeyword
          })
      }
    },
    _getResultsByHits: function (hits) {
      return _.map(hits, function (hit) {
        var originalImageUrl = hit._source.image
        var imageUrl = ''
        if (originalImageUrl.match(/\.(jpg|png)$/)) {
          var segments = hit._source.image.split('/')
          segments[0] = 'https:'
          segments[7] = 's256'
          imageUrl = segments.join('/')
        } else if (originalImageUrl.match(/=s\d+$/)) {
          imageUrl = originalImageUrl.replace(/=s\d+$/, '=s256')
        } else {
          imageUrl = originalImageUrl
        }
        return {
          title: hit._source.title,
          url: hit._source.url,
          image: imageUrl,
          descriptions: hit._source.descriptions,
          tags: hit._source.tags
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div#result-view div.card {
  width: 256px;
  /* height: 28rem; */
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 8px;
  margin-bottom: 8px;
}

div#result-view div.card img {
  width: 256px;
  height: 256px;
  object-fit: contain;
  pointer-events: none;
}

#search-form {
  padding: 10px;
}

#tags > a {
  margin: 1px;
}

@media print {
  div#result-view div.card img {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue